const userDetails = [
  { username: "priya", password: "priya@123" },
  { username: "meher", password: "meher@123" },
  { username: "vipul", password: "vipul@123" },
  { username: "abhas", password: "abhas@123" },
  { username: "nikhil", password: "nikhil@123" },
  { username: "Snehil", password: "Snehil@123" },
  { username: "PriyaSV", password: "PriyaSV@123" },
  { username: "Harman", password: "Harman@123" },
  { username: "Aakansha", password: "Aakansha@123" },
  { username: "SuryaSingh", password: "SuryaSingh@123" },
  {
    username: "shaurya@neondigital.media",
    password: "shaurya@neondigital.media@123",
  },
  { username: "Kunj", password: "Kunj@456" },
  { username: "YugNeon", password: "YugNeon@456" },
  { username: "Vedant", password: "Vedant@456" },
  { username: "Vikas", password: "Vikas@456" },
  { username: "Mohak", password: "Mohak@456" },
  { username: "Sandip", password: "Sandip@789" },
  { username: "Siddhant", password: "Siddhant@789" },
  { username: "Kanak", password: "Kanak@789" },
  { username: "Grishma", password: "Grishma@789" },
  { username: "Mihir", password: "Mihir@789" },
  { username: "Kanishka", password: "Kanishka@1012" },
  { username: "DeepakK", password: "DeepakK@1012" },
  { username: "DeepakD", password: "DeepakD@1012" },
  { username: "Himanshi", password: "Himanshi@1012" },
  { username: "Sajita", password: "Sajita@1012" },
  { username: "Vyanktesh", password: "Vyanktesh@1345" },
  {
    username: "priya@neondigital.media",
    password: "priya@neondigital.media@123",
  },
  {
    username: "mohamed@neondigital.media",
    password: "mohamed@neondigital.media@123",
  },
  {
    username: "kanak@neondigital.media",
    password: "kanak@neondigital.media@123",
  },
  {
    username: "siddhant@hectorai.live",
    password: "siddhant@hectorai.live@123",
  },
  {
    username: "neeraj@neondigital.media",
    password: "neeraj@neondigital.media@123",
  },
  {
    username: "sandip@neondigital.media",
    password: "sandip@neondigital.media@123",
  },
  {
    username: "nishtha@neondigital.media",
    password: "nishtha@neondigital.media@123",
  },
  {
    username: "suruchi@hectorai.live",
    password: "suruchi@hectorai.live@123",
  },
  {
    username: "suraj@neondigital.media",
    password: "suraj@neondigital.media@123",
  },
  {
    username: "hardik1@neondigital.media",
    password: "hardik1@neondigital.media@123"
  },
  {
    username: "s.priya",
    password: "s.priya@123",
  },
  {
    username: "manisha@hectorai.live",
    password: "manisha@hectorai.live@123",
  },
  {
    username: "sudipta@hectorai.live",
    password: "sudipta@hectorai.live@123",
  },
  {
    username: "deepak@hectorai.live",
    password: "deepak@hectorai.live@123",
  },
  {
    username: "vyanktesh@hectorai.live",
    password: "vyanktesh@hectorai.live@123",
  },
  {
    username: "vedant@hectorai.live",
    password: "vedant@hectorai.live@123",
  },
  {
    username: "dhakate.deepak@hectorai.live",
    password: "dhakate.deepak@hectorai.live@123",
  },
];

export default userDetails;
